import { Blueprint } from '../../blueprint.class';
import { BlueprintInstanceType } from '../../../shared.enums';
import { PanelItem } from '../../../panel-items/panel-item.class';
import { ToolResult } from '../../types';
import { cleanKitchenTool } from './clean-kitchen.tool';

export interface RemoveApplianceArgs {
	itemId: string;
	autoSize?: boolean;
}

export const removeApplianceTool = (blueprint: Blueprint, { itemId, autoSize }: RemoveApplianceArgs): ToolResult => {
	console.log('[removeApplianceTool] called with:', { itemId, autoSize });

	if (!itemId) {
		console.warn('[removeApplianceTool] Missing itemId');
		return { success: false, error: 'Missing itemId. Use list_appliances to get valid item IDs.' };
	}

	const kitchen = blueprint.kitchens.getActiveVersion();
	if (!kitchen) {
		console.warn('[removeApplianceTool] No active kitchen');
		return { success: false, error: 'No active kitchen found.' };
	}

	const [type, item] = kitchen.getReferenceItem(itemId);
	console.log('[removeApplianceTool] getReferenceItem result:', { type, found: !!item, itemId });

	if (!item) {
		console.warn('[removeApplianceTool] Item not found in domain model:', itemId);
		return { success: false, error: `Appliance '${itemId}' not found. Use list_appliances to get valid item IDs.` };
	}

	// Handle PanelItem removal
	if (type === BlueprintInstanceType.PanelItem) {
		// Capture the island ID before removal (typed access)
		const islandId = (item as PanelItem).refMap.island?.id;
		console.log('[removeApplianceTool] PanelItem found:', {
			itemId,
			islandId,
			hasParent: !!(item as any).instanceParent,
			hasParentChildren: !!(item as any).instanceParent?.children
		});

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const panelItem = item as any;
		// PanelItem parent is PanelItems which has children array
		if (panelItem.instanceParent && panelItem.instanceParent.children) {
			const parent = panelItem.instanceParent;
			const index = parent.children.indexOf(panelItem);
			console.log('[removeApplianceTool] Parent children index:', index, 'of', parent.children.length);
			if (index > -1) {
				parent.children.splice(index, 1);
				panelItem.cleanup();

				// Clean the island to redistribute remaining appliances
				if (islandId) {
					const cleanResult = cleanKitchenTool(blueprint, { islandId, autoResize: autoSize });
					console.log('[removeApplianceTool] cleanKitchenTool result:', cleanResult);
				}

				const result = { success: true as const, message: `Appliance '${itemId}' removed.` };
				console.log('[removeApplianceTool] Success:', result);
				return result;
			}
		}
	} else {
		console.warn('[removeApplianceTool] Unexpected type:', type, '— expected PanelItem');
	}

	const errorResult = { success: false as const, error: `Could not remove appliance '${itemId}' - type '${type}' handling not implemented.` };
	console.warn('[removeApplianceTool] Failed:', errorResult);
	return errorResult;
};
